import { render, staticRenderFns } from "./ManagerAccesses.vue?vue&type=template&id=80246c78&"
import script from "./ManagerAccesses.vue?vue&type=script&lang=js&"
export * from "./ManagerAccesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports